<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('limitCreate') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + this.$route.params.selectionId">
                        {{ data.name || $t('selection') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ $t('create') }}</li>
            </ol>
        </nav>
        <div v-for="(limit, i) in getCurrentLimit()" :key="i" class="row">
            <div class="mb-3" >
                <div class="row">
                    <div class="mb-3 col-md-4">
                        <label class="form-label" for="name" required>{{ $t('name') }}</label>
                        <input v-model="limit.name" type="text" class="form-control" id="name" >
                    </div>
                </div>
                <h4 class="form-label" for="costFactor" required>{{ $t('selectionLimitPackages') }}</h4>
                <div class="row">
                    <div class="mb-3 col-md-12">
                        <div class="row">
                            <div class="col-md-1">
                                <label class="form-label"></label>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">{{ $t('package') }}</label>
                            </div>
                            <div class="col-md-1">
                                <label class="form-label">{{ $t('unlimited') }}</label>
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">{{ $t('totalLimitValue') }}</label>
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">{{ $t('limitValue') }}</label>
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">{{ $t('inputMethod') }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 col-md-12" v-for="(limitPackage, o) in selectionLimitPackages" :key="o">
                        <div class="row">
                            <div class="col-md-1 mb-auto mt-auto">
                                <input class="form-check-input" v-model="limitPackage.checked" type="checkbox" :id="'checked_' + o">
                            </div>
                            <div class="col-md-3">
                                <input class="form-control" disabled :value="getSelectionPackageName(limitPackage.selectionPackageId)" type="text" :id="'package' + o">
                            </div>
                            <div class="col-md-1 mb-auto mt-auto">
                                <input v-model="limitPackage.unlimited" :disabled="!limitPackage.checked" class="form-check-input" :id="'unlimited' + o" type="checkbox" />
                            </div>
                            <div class="col-md-2">
                                <input v-model="limitPackage.totalLimitValue" :disabled="!limitPackage.checked || limitPackage.unlimited" class="form-control" :id="'totalLimitValue' + o" type="number" />
                            </div>
                            <div class="col-md-2">
                                <input v-model="limitPackage.limitValue" :disabled="!limitPackage.checked || limitPackage.unlimited" @input="updateYearlyLimits(limitPackage)" class="form-control" :id="'limitValue' + o" type="number" />
                            </div>
                            <div class="col-md-2">
                                <select v-model="limitPackage.inputMethod" :disabled="!limitPackage.checked || limitPackage.unlimited" @change="updateYearlyLimits(limitPackage)" class="form-select" :id="'inputMethod' + o">
                                    <option value="" disabled>{{ $t('select') }}</option>
                                    <option value="custom">{{ $t('custom') }}</option>
                                    <option value="yearly">{{ $t('yearly') }}</option>
                                    <option value="divided">{{ $t('divided') }}</option>
                                </select>
                            </div>
                            <div class="col-md-1">
                                <button class="btn btn-secondary" @click="showSelectionLimitPackageYear(limitPackage)">{{ $t('years')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   
        <div class="d-grid gap-2 d-md-flex">
            <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('create') }}</button>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}` })">{{ $t('back') }}</button>
        </div>
        <SelectionLimitPackageYearDialog v-show="showSelectionLimitPackageYearDialog" @close="showSelectionLimitPackageYearDialog = false" @confirm="showSelectionLimitPackageYearDialog = false"></SelectionLimitPackageYearDialog>
    </div>
</template>

<script>
import SelectionApi from "../../../api/server/selection";
import ForecastApi from "../../../api/server/forecast";
import ModelingApi from "../../../api/server/modeling";
import AssetTypeApi from '../../../api/server/assetType';
import SelectionLimitPackageYearDialog from "./SelectionLimitPackageYearDialog.vue";

export default {
    name: "selectionLimitcreate",
    watch: {
        $route: "requestData",
    },
    components: {
        SelectionLimitPackageYearDialog
    },
    mounted() {
        this.requestData();
    },
    methods: {
        updateYearlyLimits(limitPackage) {
            if(limitPackage.inputMethod == "yearly") {
                for(var i in limitPackage.selectionLimitPackageYear) {
                    var year = limitPackage.selectionLimitPackageYear[i];
                    year.limitValue = limitPackage.limitValue;
                }
            } else if (limitPackage.inputMethod == "divided") {
                var value = limitPackage.limitValue * limitPackage.totalLimitValue ?? 0;
                for(var i in limitPackage.selectionLimitPackageYear) {
                    var year = limitPackage.selectionLimitPackageYear[i];

                    year.limitValue = value;
                }
            }
        },
        getSelectionPackageName(id) {
            var foundPackage = this.data.selectionPackage.find(s => s.id == id);
            if(foundPackage) return foundPackage.name;
        },
        showSelectionLimitPackageYear(limitPackage) {
            this.currentSelectionLimitPackage = limitPackage;
            this.showSelectionLimitPackageYearDialog = true;
        },
        getCurrentLimit() {
            var limit = this.data.selectionLimit.filter(g => g.id == 0);
            if(limit.length > 0) {
                this.selectionLimitName = limit[0].name;
                return limit;
            } 
        },
        async requestData() {
            this.pending = true;

            var selectionId = this.$route.params.selectionId;
            this.data = await SelectionApi.selectionDetail(this.$route.params.id, selectionId);

            // Inicializace nového package
            this.data.selectionLimit.push({
                id: 0,
                selectionLimitPackage: []
            })

            var forecast = await ForecastApi.forecastDetail(this.$route.params.id, this.data.forecastId);

            var years = [];
            for (let year = forecast.startYear; year <= forecast.endYear; year++) {
                years.push(year);
            }

            var selectionLimitPackages = [];

            for(var i in this.data.selectionPackage) {
                var selectionPackage = this.data.selectionPackage[i];

                var selectionPackageObject = {
                    checked: false,
                    selectionPackageId: selectionPackage.id,
                    totalLimitValue: null,
                    limitValue: null,
                    inputMethod: "",
                    unlimited: false,
                    selectionLimitPackageYear: years.map(y => {
                        return {year: y, limitValue: 0}
                    }),
                    limitId: this.$route.params.limitId
                }

                selectionLimitPackages.push(selectionPackageObject);
            }

            this.selectionLimitPackages = selectionLimitPackages;

            var assetTypes = await AssetTypeApi.assetTypeList(this.$route.params.id);
            this.assetTypes = assetTypes.filter(f => forecast.forecastAssetTypes.findIndex(a => a.assetTypeId == f.id) >= 0);

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            
            this.pending = false;
        },
        async onSubmit() {
            try {
                var selectionLimit = this.data.selectionLimit.find(g => g.id == 0);
                if(selectionLimit.name && selectionLimit.name.length > 0) {
                    var selectionLimitPackages = [];

                    for (var i in this.selectionLimitPackages) {
                        var limitPackage = this.selectionLimitPackages[i];
                        var limitPackageObject = {
                            "id": limitPackage.id || 0,
                            "selectionPackageId": limitPackage.selectionPackageId,
                            "totalLimitValue": limitPackage.totalLimitValue,
                            "limitValue": limitPackage.limitValue,
                            "unlimited": limitPackage.unlimited,
                            "inputMethod": limitPackage.inputMethod,
                            "selectionLimitPackageYear": limitPackage.selectionLimitPackageYear
                        }

                        if(limitPackage.checked) {
                            if(limitPackage.unlimited) {
                                limitPackageObject.totalLimitValue = null;
                                limitPackageObject.limitValue = 0;
                                limitPackageObject.inputMethod = "";
                                limitPackageObject.selectionLimitPackageYear = []
                            }

                            if(limitPackageObject.totalLimitValue === "") 
                                limitPackageObject.totalLimitValue = null;

                            if(limitPackageObject.limitValue === "") 
                                limitPackageObject.limitValue = null;

                            selectionLimitPackages.push(limitPackageObject);
                        }
                    }

                    var foundInvalid = selectionLimitPackages.find(s => !s.unlimited && s.limitValue == null);
                    if(foundInvalid) {
                        this.showEmptyInputsError();
                    } else {
                        selectionLimit.selectionLimitPackage = selectionLimitPackages;
                        
                        await SelectionApi.selectionUpdate(this.$route.params.id, this.data);
                        this.showSuccess();
                        this.$router.go(-1);
                    }
                } else {
                    this.showEmptyNameError();
                }
            } catch {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: 'success',
            message: 'selectionLimitCreated',
            type: 'success'
        },
        showError: {
            title: 'error',
            message: 'selectionLimitError',
            type: 'error'
        },
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        },
        showEmptyInputsError: { 
            title: 'error',
            message: 'limitPackagesMissingValues',
            type: 'error'
        }
    },
    data() {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroup: [],
                selectionPackage: [],
                selectionLimit: []
            },
            selectionLimitName: "",
            years: [],
            assetTypes: [],
            pending: true,
            modelingName: "",
            selectionLimitPackages: [],
            showSelectionLimitPackageYearDialog: false,
            currentSelectionLimitPackage: {
                selectionLimitPackageYear: []
            },
            disableEditForCurrentYears: false
        }
    }
};
</script>